import { gql } from "@apollo/client";
import { WarehouseType } from "../../../../../../graphql/types/WarehouseType";

export const GET_HUB_LIST = gql`
    query GetHubList {
        hubList: getHubList {
            id
            name
            sortingCode
            siteType
        }
    }
`;

export interface GetHubListResponse {
    hubList: WarehouseType[];
}

